<template>
	
	<article class="ingredient-tile columns is-gapless">
		<div class="column is-3 flex-middle">
			<a :href="ingredient.url">
				<img class="featured" :src="ingredient.imageUrl"/>
			</a>
		</div>
		<div class="column flex-column-middle-left">
			<div class="details">
				<a :href="ingredient.url">
					<h3 class="title is-3">{{ingredient.name}}</h3>
				</a>
				<div v-html="ingredient.benefit"></div>
			</div>
		</div>
	</article>
	
</template>
	
<script>
	export default {
		name: 'IngredientTile',
		
		props: ["ingredient"],
		
		data() {
			return {
				
			};
		},
	
		methods: {
			
		}
	}
</script>
